module.exports = __webpack_public_path__ + "static/media/icons-ic-join-call-alt.58db5159.svg";